import { render } from "./CalculatorBlock.vue?vue&type=template&id=2ea3ba41&ts=true"
import script from "./CalculatorBlock.vue?vue&type=script&lang=ts"
export * from "./CalculatorBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__